import React from "react";
import { Route, Routes } from "react-router-dom";
import StatementV2 from "./templates/StatementV2";
import AppfolioStatement from "./templates/AppfolioStatement";
import ResidentInvite from "./templates/ResidentInvite";
import AppfolioResidentInvite from "./templates/AppfolioResidentInvite";

const App = () => {
  return (
    <div>
      <Routes>
        <Route
          exact
          path="/"
          element={<div>Paper correspondence templates</div>}
        />
        <Route exact path="/statement" element={<StatementV2 />} />
        <Route
          exact
          path="/appfolio-statement"
          element={<AppfolioStatement />}
        />
        <Route exact path="/resident-invite" element={<ResidentInvite />} />
        <Route
          exact
          path="/appfolio/resident-invite"
          element={<AppfolioResidentInvite />}
        />
      </Routes>
    </div>
  );
};
export default App;
